import { PageModule } from 'app/pages/types';
import React from 'react';
import Exception from './Exception';

export const ExceptionModule: PageModule = {
  pageIf: (page, exception) => Boolean(exception),
  render: (page, exception) => <Exception exception={exception!} />
};
